var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector84(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 320,
    viewBox: "0 0 342 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.836 318.717C315.599 299.116 311.758 294.847 296.404 274.734C292.642 269.806 286.723 260.227 281.07 248.395C279.376 244.854 277.839 241.343 276.431 237.881C266.385 213.106 264.967 185.351 267.301 157.94C273.26 88.0017 235.402 24.8791 178.084 6.47729C120.667 -11.954 56.9072 18.3681 25.7957 65.6855C21.748 71.8424 3.8926 100.896 1.2532 132.772C-7.10821 233.416 90.3824 273.632 238.721 304.082C241.607 304.672 255.345 306.925 258.26 307.328L339.846 318.727L339.836 318.717Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector84);
export default __webpack_public_path__ + "static/media/vector8-4.a80ee0335f523feba80e1ba145dabb70.svg";
export { ForwardRef as ReactComponent };